export type TipoNegocioPedido = "primeira_venda" | "renovacao";

export type SituacaoRenovacaoPedido =
  | "em_vigencia"
  | "aguardando_renovacao"
  | "renovado"
  | "nao_renovado";

export type ConfirmacaoVendaStatus = "aguardando" | "confirmada" | "cancelada";

export const TIPO_NEGOCIO_LABELS: Record<TipoNegocioPedido, string> = {
  primeira_venda: "Primeira venda",
  renovacao: "Renovação",
};

export const SITUACAO_RENOVACAO_LABELS: Record<SituacaoRenovacaoPedido, string> = {
  em_vigencia: "Em vigência",
  aguardando_renovacao: "Aguardando renovação",
  renovado: "Renovado",
  nao_renovado: "Não renovado",
};

export const CONFIRMACAO_VENDA_LABELS: Record<ConfirmacaoVendaStatus, string> = {
  aguardando: "Aguardando",
  confirmada: "Confirmada",
  cancelada: "Cancelada",
};

export function getTipoNegocioBadgeClass(tipo: TipoNegocioPedido | string | null | undefined) {
  if (tipo === "renovacao") return "bg-blue-100 text-blue-800";
  return "bg-emerald-100 text-emerald-800";
}

export function getSituacaoRenovacaoBadgeClass(situacao: SituacaoRenovacaoPedido | string | null | undefined) {
  switch (situacao) {
    case "aguardando_renovacao":
      return "bg-amber-100 text-amber-800";
    case "renovado":
      return "bg-green-100 text-green-800";
    case "nao_renovado":
      return "bg-red-100 text-red-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
}

export function getConfirmacaoVendaBadgeClass(
  status: ConfirmacaoVendaStatus | string | null | undefined
) {
  switch (status) {
    case "aguardando":
      return "bg-amber-100 text-amber-800";
    case "confirmada":
      return "bg-green-100 text-green-800";
    case "cancelada":
      return "bg-red-100 text-red-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
}

export function formatTipoNegocio(tipo: string | null | undefined) {
  if (tipo === "renovacao") return TIPO_NEGOCIO_LABELS.renovacao;
  return TIPO_NEGOCIO_LABELS.primeira_venda;
}

export function resolverNumeroCiclo(
  numeroCiclo?: number | null,
  tipoNegocio?: string | null
): number {
  const n = Number(numeroCiclo);
  if (Number.isFinite(n) && n >= 1) return Math.floor(n);
  return tipoNegocio === "renovacao" ? 2 : 1;
}

/** 1ª venda, 2ª venda, 3ª venda… */
export function formatNumeroCicloVenda(
  numeroCiclo?: number | null,
  tipoNegocio?: string | null
): string {
  return `${resolverNumeroCiclo(numeroCiclo, tipoNegocio)}ª venda`;
}

/** Agenda: 1ª venda, 2ª venda, 3ª venda… */
export function formatAgendaCicloLabel(
  numeroCiclo?: number | null,
  tipoNegocio?: string | null
): string {
  return formatNumeroCicloVenda(numeroCiclo, tipoNegocio);
}

export function proximoNumeroCiclo(
  numeroCicloOrigem?: number | null,
  tipoNegocioOrigem?: string | null
): number {
  return resolverNumeroCiclo(numeroCicloOrigem, tipoNegocioOrigem) + 1;
}

/** Label exibida na coluna Status da listagem de pedidos */
export function getStatusListagemLabel(
  tipo: string | null | undefined,
  numeroCiclo?: number | null
) {
  return formatNumeroCicloVenda(numeroCiclo, tipo);
}

export function getStatusListagemBadgeClass(
  tipo: string | null | undefined,
  numeroCiclo?: number | null
) {
  const ciclo = resolverNumeroCiclo(numeroCiclo, tipo);
  return ciclo <= 1 ? "bg-emerald-100 text-emerald-800" : "bg-blue-100 text-blue-800";
}

export function formatDataRenovacaoListagem(data?: string | null) {
  if (!data) return "—";
  return new Date(`${data}T12:00:00`).toLocaleDateString("pt-BR");
}

export function formatSituacaoRenovacao(situacao: string | null | undefined) {
  if (situacao && situacao in SITUACAO_RENOVACAO_LABELS) {
    return SITUACAO_RENOVACAO_LABELS[situacao as SituacaoRenovacaoPedido];
  }
  return SITUACAO_RENOVACAO_LABELS.em_vigencia;
}

export function formatConfirmacaoVenda(status: string | null | undefined) {
  if (status && status in CONFIRMACAO_VENDA_LABELS) {
    return CONFIRMACAO_VENDA_LABELS[status as ConfirmacaoVendaStatus];
  }
  return "—";
}
